var React = require('react');

function StrictLine (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"直线"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeOpacity":"0.3","key":1},React.createElement("g",{"transform":"translate(-92.000000, -5450.000000)","stroke":"#9B9B9B"},React.createElement("line",{"x1":"92.5","y1":"5450.5","x2":"92.5","y2":"9064.5"})))]);
}

StrictLine.defaultProps = {"width":"1px","height":"3615px","viewBox":"0 0 1 3615","version":"1.1"};

module.exports = StrictLine;

StrictLine.default = StrictLine;
